<template>
  <div class="demo">

    <div class="content">
      <div class="block blue" v-intersection="handler" ref="ok"></div>
      <div class="block"></div>
    </div>

    <span class="tip button1" :class="isShow ? 'green' : 'red'">isShow?:{{ isShow }} times:{{ times }}</span>
    <span class="tip button orange pointer" @click="click">
      click me unobserve this target
    </span>

  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: "???",
      times: 0,
    };
  },
  computed: {},
  methods: {
    click() {
      this.$refs.ok._observe.observer.disconnect();

    },
    handler(entries) {

      entries[0].isIntersecting ? (this.isShow = true) : (this.isShow = false);
      this.times++;


   
    },

  },
};
</script>

<style lang="css">
.demo {
  position: relative;
  border-radius: 20px;

  border: 1px solid #cccccc;
  overflow: hidden;
}
.content {
  width: 100%;
  height: 30vh;
  overflow-y: scroll;
}

.block {
  width: 10vh;
  height: 10vh;
  margin: 40vh auto;
  margin-bottom: 20%;

  border-radius: 20px;
}
</style>
